import { assign, cloneDeep } from 'lodash'

import Access from 'global-utils/models/Access'

import * as teamPage from './TeamPageActions'

export default (state = teamPage.TEAM_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case teamPage.TEAM_FETCH: {
      return state
    }
    case teamPage.TEAM_FETCH_CANCELED: {
      return cloneDeep(teamPage.TEAM_INITIAL_STATE)
    }
    case teamPage.TEAM_FETCH_ERROR: {
      return assign(cloneDeep(state), { error: action.payload, posts: [] })
    }
    case teamPage.TEAM_FETCH_FULFILLED: {
      const newState = assign(cloneDeep(state), action.payload)
      newState.data[0].access = new Access(newState.data[0].access)
      return newState
    }

    case teamPage.TEAM_LIKE: {
      return state
    }
    case teamPage.TEAM_LIKE_CANCELED: {
      return state
    }
    case teamPage.TEAM_LIKE_ERROR: {
      return state
    }
    case teamPage.TEAM_LIKE_FULFILLED: {
      const liked = action.payload?.data?.[0]?.like
      const newState = cloneDeep(state)

      if (liked) {
        newState.data[0].liked = {
          liked: true,
        }
        newState.data[0].following = {
          follow: true,
        }
        newState.data[0].likes_count += 1
        newState.data[0].follows_count += 1
      } else {
        newState.data[0].liked = null
        newState.data[0].following = null
        newState.data[0].likes_count -= 1
        newState.data[0].follows_count -= 1
      }
      return newState
    }

    case teamPage.TEAM_RELATION_FETCH: {
      return state
    }
    case teamPage.TEAM_RELATION_FETCH_CANCELED: {
      return state
    }
    case teamPage.TEAM_RELATION_FETCH_ERROR: {
      return state
    }
    case teamPage.TEAM_RELATION_FETCH_FULFILLED: {
      const data = action.payload.data[0]
      const newState = cloneDeep(state)
      newState.data[0] = assign(newState.data[0], data)
      newState.data[0].access = new Access(newState.data[0].access)
      return newState
    }
    default:
  }
  return state
}
